module.exports = __webpack_public_path__ + "static/media/BuhlerTAS204-A4.cbeaa1a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/presets/photos/BuhlerTAS204-A4.jpg
// module id = 153
// module chunks = 0